module.exports = __webpack_public_path__ + "img/machine-0.47a8dbad.svg";